"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (flkty, previousBtn, nextBtn) {
    var updateButtonStyles = function () {
        var indx = flkty.selectedIndex;
        var cellsLength = flkty.cells.length;
        if (!previousBtn || !nextBtn)
            return;
        if (indx === 0) {
            previousBtn.disabled = true;
            previousBtn.classList.add('is-disabled');
        }
        else {
            previousBtn.disabled = false;
            previousBtn.classList.remove('is-disabled');
        }
        if (indx === (cellsLength - 1)) {
            nextBtn.disabled = true;
            nextBtn.classList.add('is-disabled');
        }
        else {
            nextBtn.disabled = false;
            nextBtn.classList.remove('is-disabled');
        }
    };
    if (previousBtn) {
        previousBtn.addEventListener('click', function () {
            flkty.previous();
            updateButtonStyles();
        });
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', function () {
            flkty.next();
            updateButtonStyles();
        });
    }
    updateButtonStyles();
});
